// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3XhU9","image":"App_image__1uEq6"};